import { ref } from "vue";

const addEventBottomSheetOpen = ref(false);
const editEventBottomSheetOpen = ref(false);
const selectedEventData = ref<any>(null);

export function useEventManagement() {
  function openAddEventBottomSheet() {
    addEventBottomSheetOpen.value = true;
  }

  function closeAddEventBottomSheet() {
    addEventBottomSheetOpen.value = false;
  }

  function openEditEventBottomSheet(eventData: any) {
    selectedEventData.value = eventData;
    // Use requestAnimationFrame to ensure the transition triggers properly
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        editEventBottomSheetOpen.value = true;
      });
    });
  }

  function closeEditEventBottomSheet() {
    editEventBottomSheetOpen.value = false;
    setTimeout(() => {
      selectedEventData.value = null;
    }, 300);
  }

  return {
    addEventBottomSheetOpen,
    editEventBottomSheetOpen,
    selectedEventData,
    openAddEventBottomSheet,
    closeAddEventBottomSheet,
    openEditEventBottomSheet,
    closeEditEventBottomSheet,
  };
}
